/* eslint-disable */
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';

// actions
import { getGroups as fetchGroups } from '../../store/actions/groups';

// selectors
import { getFilteredGroups } from '../../store/selectors/groups';

const useGroups = () => {
  const [isLoading, setIsLoading] = useState(false)
  const dispatch = useDispatch();
  const groups = useSelector(getFilteredGroups);

  const getGroups = async (searchText = '') => {
    try {
      setIsLoading(true);
      const res = await dispatch(fetchGroups(searchText)).unwrap();
      const groups = res.resources
      if (groups.length === 0) {
        toast.error('No matching records found, please modify your search and try again')
      }
    } catch (error) {
      toast.error(error?.message)
    } finally {
      setIsLoading(false)
    }
  };

  return { groups, areGroupsLoading: isLoading, getGroups };
};

export default useGroups;
